<template>
  <div class="exhibitionList">
    <BackgroundCircle class="backgroundCircle" />

    <div class="web d-none d-mb-block">
      <!-- title -->
      <div class="d-flex align-items-center justify-content-center">
        <h1 class="title textColor">歷屆畢業展</h1>
      </div>

      <!-- content -->
      <div class="content mb-46 d-flex align-items-start justify-content-center" v-for="item in list" :key="item.id">
        <div class="w-100 mr-20 content__img cur-pointer">
          <img :src="imgURL + item.coverPic.path" :alt="item.coverPic.name" @click="goProductList(item)" />
        </div>
        <div class="w-100 d-flex flex-column align-items-start justify-content-start">
          <div class="content__title cur-pointer" @click="goProductList(item)">
            <h3 class="m-0">{{ item.title }}</h3>
          </div>
          <p class="content__descript--text mt-12" v-html="item.contents">
            <!-- <vue-editor v-model="item.contents" :disabled="true"></vue-editor> -->
            <!-- {{ item.contents }} -->
          </p>
        </div>
      </div>
    </div>

    <div class="phone d-block d-mb-none">
      <div class="d-flex align-items-center justify-content-center">
        <h1 class="title textColor">歷屆畢業展</h1>
      </div>

      <div
        class="content mb-46 d-flex flex-column align-items-center justify-content-center cur-pointer"
        v-for="item in list"
        :key="item.id"
        @click="goProductList(item)"
      >
        <img :src="imgURL + item.coverPic.path" :alt="item.coverPic.name" />
        <div class="my-8 d-flex flex-column align-items-center justify-content-center">
          <div class="content__title textColor">
            {{ item.title }}
          </div>
          <p class="content__descript" v-html="item.contents">
            <!-- {{ item.contents }} -->
          </p>
        </div>
      </div>
    </div>

    <div class="w-100 pb-40">
      <Pagination
        :needPage="true"
        :total="total"
        :page="listQuery.page"
        @choosePage="choosePage"
        @works_prev="works_prev"
        @works_next="works_next"
      />
    </div>
  </div>
</template>

<script>
import BackgroundCircle from "@/components/BackgroundCircle";
import Pagination from "@/components/Pagination.vue";

export default {
  components: {
    BackgroundCircle,
    Pagination,
  },
  data() {
    return {
      imgURL: process.env.VUE_APP_BASE_IMG_URL,
      list: [],
      total: 0,
      listQuery: {
        page: 1,
        limit: 10,
      },
    };
  },
  methods: {
    choosePage(number) {
      this.listQuery.page = number;
      this.getGraduateList();
    },
    works_prev(page) {
      this.listQuery.page = page;
      this.getGraduateList();
    },
    works_next(page) {
      this.listQuery.page = page;
      this.getGraduateList();
    },
    goProductList(item) {
      this.$router.push({
        name: "product",
        params: { id: item.id },
        query: {
          year: item.annual,
          routerName: "product",
          groupTypeId: this.groupTypeId,
        },
      });
    },
    getGraduateList() {
      this.$store.commit("SETLOADING", true);
      this.$api.getGraduateList(this.listQuery).then((res) => {
        const { code, data, count } = res.data;
        if (code === 200) {
          this.list = data;
          document.documentElement.scrollTop = 0;
          this.list.forEach((item, index) => {
            try {
              this.list[index].coverPic = JSON.parse(item.coverPic);
            } catch (error) {
              console.log(error);
            }
          });
          this.total = Math.ceil(count / this.listQuery.limit);
          this.$store.commit("SETLOADING", false);
        }
      });
    },
    getGroupList() {
      this.$api.getGroupTypeList().then((res) => {
        const { code, data } = res.data;
        if (code === 200) {
          this.groupTypeId = data[0].dtCode;
        }
      });
    },
  },
  mounted() {
    this.getGroupList();
    this.getGraduateList();
  },
};
</script>

<style lang="scss">
.exhibitionList {
  position: relative;
  overflow: hidden;
  z-index: 1;

  @media (min-width: 1024px) {
    margin-bottom: 120px;
  }

  .textColor {
    background: linear-gradient(180deg, #ceb87f 0%, #fff2d0 100%);
    background-clip: text;
    -webkit-background-clip: text;
    color: transparent;
  }
  .backgroundCircle {
    position: absolute;
    // bottom: 50%;
    z-index: -1;
  }

  .web {
    .title {
      font-size: 64px;
      line-height: 75px;
    }

    .content {
      padding: 0 180px;
      &__img {
        display: flex;
        justify-content: center;
        align-items: center;
        background-size: contain;
        width: 450px;
        border: 1px solid #596164;
        overflow: hidden;
        &:hover {
          border: 1px solid #e7d5a7;
          transition: 0.5s;
          img {
            transform: scale(1.2);
            transition: 0.8s;
          }
        }

        img {
          width: 100%;
          height: 100%;
        }
      }

      &__title {
        color: #fff;
        font-size: 24px;
        line-height: 28px;
        &:hover {
          h3 {
            background: linear-gradient(180deg, #ceb87f 0%, #fff2d0 100%);
            background-clip: text;
            -webkit-background-clip: text;
            color: transparent;
            mask-image: linear-gradient(-75deg, rgba(0, 0, 0, 0.6) 30%, #000 50%, rgba(0, 0, 0, 0.6) 70%);
            mask-size: 200%;
            animation: shine 2s infinite;
          }

          @keyframes shine {
            from {
              -webkit-mask-position: 150%;
            }
            to {
              -webkit-mask-position: -50%;
            }
          }
        }
      }
      &__descript {
        color: #fff;
        font-size: 18px;
        line-height: 26px;
        letter-spacing: 0.02em;

        &--text {
          color: #fff;
          .ql-editor {
            min-height: 50px;
          }
          .ql-toolbar {
            display: none !important;
          }
          .ql-container {
            border: none !important;
            ol {
              padding-left: 0;
            }
          }
        }
      }
    }
  }
  .phone {
    .title {
      margin-top: 50px;
      margin-bottom: 10px;
      font-size: 24px;
    }

    .content {
      padding: 0 28px;
      img {
        width: 100%;
      }
      &__title {
        font-size: 20px;
        line-height: 23px;
      }
      &__descript {
        color: #fff;
        font-size: 16px;
        line-height: 26px;
        letter-spacing: 0.02em;
      }
    }
  }
}
</style>